const tableMetadata = [
  {
    id: 'debitsuccessId',
    renderingField: 'debitsuccessIdRender',
    width: '10%',
    numeric: false,
    disablePadding: false,
    label: 'Debitsuccess ID',
    alignment: 'left',
  },
  {
    id: 'businessId',
    renderingField: 'businessId',
    width: '10%',
    numeric: false,
    hideInMobile: true,
    disablePadding: false,
    label: 'Business ID',
    alignment: 'left',
  },
  {
    id: 'name',
    renderingField: 'name',
    width: '20%',
    numeric: false,
    disablePadding: false,
    label: 'Name',
    alignment: 'left',
  },
  {
    id: 'facilityName',
    renderingField: 'facilityName',
    width: '20%',
    numeric: false,
    hideInMobile: true,
    disablePadding: false,
    label: 'Business name',
    alignment: 'left',
  },
  {
    id: 'contact',
    renderingField: 'contact',
    width: '10%',
    numeric: false,
    hideInMobile: true,
    disablePadding: false,
    label: 'Contact',
    alignment: 'left',
  },
  {
    id: 'dob',
    renderingField: 'dobRender',
    width: '10%',
    numeric: false,
    hideInMobile: true,
    disablePadding: false,
    label: 'Date of birth',
    alignment: 'left',
  },
  {
    id: 'status',
    renderingField: 'statusRender',
    width: '20%',
    numeric: false,
    disablePadding: false,
    label: 'Status',
    alignment: 'left',
  },
];

export default tableMetadata;
